/* GENERAL */
export const GET_NO_APPOINTMENT_CHART = "GET_NO_APPOINTMENT_CHART"
export const GET_NO_APPOINTMENT_CHART_SUCCESS = "GET_NO_APPOINTMENT_CHART_SUCCESS"
export const GET_NO_APPOINTMENT_CHART_FAIL = "GET_NO_APPOINTMENT_CHART_FAIL"

export const GET_CLINIC_APPOINTMENT_RATE = "GET_CLINIC_APPOINTMENT_RATE"
export const GET_CLINIC_APPOINTMENT_RATE_SUCCESS = "GET_CLINIC_APPOINTMENT_RATE_SUCCESS"
export const GET_CLINIC_APPOINTMENT_RATE_FAIL = "GET_CLINIC_APPOINTMENT_RATE_FAIL"

export const GET_PREEMPLOYMENT_RATE = " GET_PREEMPLOYMENT_RATE"
export const GET_PREEMPLOYMENT_RATE_SUCCESS = " GET_PREEMPLOYMENT_RATE_SUCCESS"
export const GET_PREEMPLOYMENT_RATE_FAIL = " GET_PREEMPLOYMENT_RATE_FAIL"

export const GET_TELECONSULT_RATE = "GET_TELECONSULT_RATE"
export const GET_TELECONSULT_RATE_SUCCESS = "GET_TELECONSULT_RATE_SUCCESS"
export const GET_TELECONSULT_RATE_FAIL = "GET_TELECONSULT_RATE_FAIL"

export const GET_NO_PATIENT_RATE = "GET_NO_PATIENT_RATE"
export const GET_NO_PATIENT_RATE_SUCCESS = "GET_NO_PATIENT_RATE_SUCCESS"
export const GET_NO_PATIENT_RATE_FAIL = "GET_NO_PATIENT_RATE_FAIL"

export const GET_ATTACHMENT = "GET_ATTACHMENT"
export const GET_ATTACHMENT_SUCCESS = "GET_ATTACHMENT_SUCCESS"
export const GET_ATTACHMENT_FAIL = "GET_ATTACHMENT_FAIL"

export const GET_EXPORT_CLINIC_APPOINTMENT = "GET_EXPORT_CLINIC_APPOINTMENT"
export const GET_EXPORT_CLINIC_APPOINTMENT_SUCCESS = "GET_EXPORT_CLINIC_APPOINTMENT_SUCCESS"
export const GET_EXPORT_CLINIC_APPOINTMENT_FAIL = "GET_EXPORT_CLINIC_APPOINTMENT_FAIL"

export const GET_EXPORT_PREEMPLOYMENT = "GET_EXPORT_PREEMPLOYMENT"
export const GET_EXPORT_PREEMPLOYMENT_SUCCESS = "GET_EXPORT_PREEMPLOYMENT_SUCCESS"
export const GET_EXPORT_PREEMPLOYMENT_FAIL = "GET_EXPORT_PREEMPLOYMENT_FAIL"

export const GET_EXPORT_TELECONSULTATION = "GET_EXPORT_TELECONSULTATION"
export const GET_EXPORT_TELECONSULTATION_SUCCESS = "GET_EXPORT_TELECONSULTATION_SUCCESS"
export const GET_EXPORT_TELECONSULTATION_FAIL = "GET_EXPORT_TELECONSULTATION_FAIL"

export const GET_EXPORT_PATIENT = "GET_EXPORT_PATIENT"
export const GET_EXPORT_PATIENT_SUCCESS = "GET_EXPORT_PATIENT_SUCCESS"
export const GET_EXPORT_PATIENT_FAIL = "GET_EXPORT_PATIENT_FAIL"

export const GET_EXPORT_ADMIN = "GET_EXPORT_ADMIN"
export const GET_EXPORT_ADMIN_SUCCESS = "GET_EXPORT_ADMIN_SUCCESS"
export const GET_EXPORT_ADMIN_FAIL = "GET_EXPORT_ADMIN_FAIL"

export const RESET_DASHBOARD = 'RESET_DASHBOARD';
